// src/widgets/ClockWidget.jsx
import { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

export default function ClockWidget() {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <div style={{
      height: '100%',
      boxSizing: 'border-box',
      background: 'var(--bg-card)',
      border: '1px solid var(--border)',
      borderRadius: 'var(--radius-lg)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 6,
      padding: 16,
    }}>
      <Clock size={16} color="var(--accent-blue)" style={{ marginBottom: 2 }} />
      <div style={{
        fontSize: 32,
        fontWeight: 700,
        fontFamily: 'var(--font-mono)',
        color: 'var(--text-primary)',
        letterSpacing: '0.02em',
      }}>
        {now.toLocaleTimeString('id-ID', { hour12: false })}
      </div>
      <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>
        {now.toLocaleDateString('id-ID', { weekday: 'long' })}
      </div>
    </div>
  );
}